export interface EnvConfig {
  baseUrl?: string;
  production?: boolean;
  disableFieldValidation?: boolean,
  luvemaApiKey: string
}

export const environment: EnvConfig = {
  production: false,
  // baseUrl: 'https://localhost:44381/api', // LOCAL
  //baseUrl: 'https://luvemaapi.azurewebsites.net/api', // old
  //baseUrl: 'https://luvemaapidev.azurewebsites.net/api', // DEV
  // baseUrl: 'https://luvemaapitest.azurewebsites.net/api', // TEST
  baseUrl: 'https://luvemaapiprod.azurewebsites.net/api', // PROD
  disableFieldValidation: false,
  luvemaApiKey: 'Kasdu3IDAus38kJC'
};

